import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { VerifySectionComponent } from './containers/verify-section/verify-section.component';
import { VerifySectionComponent } from '../../app/verify/containers/verify-section/verify-section.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [VerifySectionComponent]
})
export class VerifySectionModule { }
